import React from 'react';

import { hookFormFieldHoc, HookFormFieldCoreProps } from '../field.hoc';

import styles from './CheckboxField.module.scss';

interface CheckboxFieldProps extends HookFormFieldCoreProps {
  label: React.ReactNode;
  className?: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  getSelectedCount?: () => number;
  maxCount?: number;
  nlogAreaCode?: string;
}

export const Checkbox: React.FC<CheckboxFieldProps> = ({
  field,
  label,
  checked,
  className,
  onChange,
  getSelectedCount,
  maxCount,
  nlogAreaCode,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (maxCount && getSelectedCount) {
      if (getSelectedCount() < maxCount || field?.value) {
        onChange?.(e);
        field?.onChange?.(e);
      }
    } else {
      onChange?.(e);
      field?.onChange?.(e);
    }
  };

  return (
    <label className={className || styles.checkbox}>
      <input
        type="checkbox"
        {...field}
        checked={field?.value || checked || false}
        onChange={handleChange}
        {...(nlogAreaCode ? { 'data-event-nlog': 'click', 'data-event-area-code': nlogAreaCode } : {})}
      />
      {label}
    </label>
  );
};

export default hookFormFieldHoc(Checkbox);
